import React from 'react'
import { shubham } from '../assets';
import Tilt from 'react-parallax-tilt';
import { useTranslation } from 'react-i18next';
import RightScroll from '../animattion/RightScroll';


const About = () => {

  const { t } = useTranslation();

  return (
    <div id='About' className="h-auto w-auto md:pt-10">
      <p className='text-center text-[2rem] font-bold'>{t('About')}</p>
      <div className='py-6 flex flex-col flex-wrap md:flex-row'>
        {/* left box */}
        
          <div className="flex flex-wrap md:w-[50%] md:justify-center md:px-4">
            <p className='text-xl text-justify'> {t('About_txt')}
            </p>
          </div>
      

        {/* right box */}
        
        <div className="h-auto flex flex-wrap justify-center items-center md:w-[50%] md:h-auto overflow-x-clip ">
          <RightScroll >
          <Tilt className='w-auto h-[20rem] rounded-[50%] py-4 md:py-0 md:h-[14rem] md:w-[14rem] shadow-2xl shadow-blue'>
            <img src={shubham} alt="shubham vaishnav " className='h-[inherit] w-[inherit] rounded-[50%]' />
          </Tilt>
          </RightScroll>
        </div>
        
      </div>

    </div>
  )
}

export default About;